/*import Members from './Members';*/
import { Link } from 'react-router-dom';
import members from '../data/members'; // huolehdi datatiedostosta
import Listen from './Listen';
import Info from './Info';
import Contact from './Contact';
import './Home.css';


function Home() {
  
  return (
    <main id="top" > 
    <div className="info-hero">
        <img src="/images/kvartetti.jpeg" alt="Lumo Ensemble esiintymässä" />
       </div>
       <div className="hero-message">
  <h1><em>Live Music</em> <span>on a</span> <br/><strong>String Quartet</strong></h1>
  <p className="events">Konsertit&nbsp;&nbsp;&nbsp;Häät&nbsp;&nbsp;&nbsp;Tapahtumat</p>
  <div className="cta-block">
    <h2>KIINNOSTUITKO?</h2>
    <a href="#contact" className="cta-button">Ota meihin yhteyttä!</a>
  </div>
</div>

     
       <Listen/>
      <Info />
      <section id="members" className="section">
        <h2>Jäsenet</h2>
        <div  className="members-grid">
        {members.map(m => (
          <Link to={`/member/${m.id}`} key={m.id} className="member-card">
            <img src={m.cardImage} alt={m.name} />
            <h3>{m.name}</h3>
            <p>{m.instrument}</p>
          </Link>
        ))}
        </div>
        
      </section>
      <Contact />
    </main>
  );
}


export default Home;
